// extracted by mini-css-extract-plugin
export default {"modalContainer":"I3","fadeIn":"J3","img":"K3","fadeInImg":"L3","greeting":"M3","fadeInGreeting":"N3","imgWrapper":"O3","name":"P3","fadeInName":"Q3"};
    if(module.hot) {
      // 1714442371697
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  